import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function ForbiddenPage() {
  useEffect(() => {
    document.title = 'Adgang nægtet (403) - SKI & CO TRAVEL ApS'
  }, [])

  return (
    <div className="max-w-4xl mx-auto px-4 py-20 text-center space-y-8">
      <div className="w-24 h-24 rounded-3xl bg-amber-500/10 text-amber-400 border border-amber-500/20 flex items-center justify-center mx-auto text-4xl shadow-xl">
        <i className="fa-solid fa-lock" aria-hidden="true" />
      </div>

      <div className="space-y-3">
        <span className="text-xs font-bold uppercase tracking-widest text-amber-400">
          Fejl 403
        </span>
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-white">
          Adgang nægtet
        </h1>
        <p className="text-slate-300 text-base max-w-lg mx-auto leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side. Du kan navigere tilbage til vores rejseunivers eller kontakte os for hjælp.
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
        <Link
          to="/"
          className="px-6 py-3.5 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-sm transition-colors"
        >
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="px-6 py-3.5 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm border border-slate-700 transition-colors"
        >
          Kontakt SKI & CO TRAVEL
        </Link>
        <a
          href="tel:+4551589452"
          className="px-6 py-3.5 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm border border-slate-700 transition-colors inline-flex items-center gap-2"
        >
          <i className="fa-solid fa-phone text-cyan-400" aria-hidden="true" />
          <span>+45 51 58 94 52</span>
        </a>
      </div>
    </div>
  )
}
